export type StatusCardType = 'alert' | 'info' | 'error';

export const StatusCardType = {
	Alert: 'alert' as StatusCardType,
	Info: 'info' as StatusCardType,
	Error: 'error' as StatusCardType,
};
